import { gsap } from "gsap";

export default {
	name: 'default',
    leave({ current, next, trigger }) {
        return new Promise(async resolve => {
            document.dispatchEvent(new CustomEvent('disable-scroll'));

			gsap.to(current.container, {
				autoAlpha: 0,
				duration: 0.25,
				ease: 'sine.out',
				onComplete: () => {
					resolve();
				},
			});
        });
    },
	afterLeave({ current, next, trigger }) {
		return new Promise(resolve => {
			gsap.set(next.container, {
				autoAlpha: 0
			});

			gsap.set(current.container, {
				position: 'absolute',
				top: 0,
				left: 0,
				width: current.container.getBoundingClientRect().width,
				zIndex: -10,
			});

            resolve();
		});
	},
    enter({ current, next, trigger }) {
        return new Promise(resolve => {
            window.scrollTo(0, -1);
			resolve();
        });
    },
	afterEnter({ current, next, trigger }) {
		return new Promise(resolve => {
			window.scrollTo(0, -1);

			document.dispatchEvent(new CustomEvent('enable-scroll'));

			gsap.to(next.container, {
				autoAlpha: 1,
				ease: 'sine.in',
				duration: 0.25,
				onComplete: () => {
					resolve();
				},
			});

		});
	},
};
